<div class="container">
  <div class="content">
    <div class="logo-section">
      <img class="logo" src="assets/icons/tc_logo.svg" alt="tc-logo" />
    </div>
    <div class="title-section">
      <h1 class="title">Registrate</h1>
      <h2 class="subtitle">¡Nos emociona que seas parte!</h2>
    </div>
    <div class="signin-form" [formGroup]="registerForm">
      <app-reminder-message
        *ngIf="!environment.production"
        [message]="warningMessage"
        [type]="'error'"
      >
      </app-reminder-message>
      <div class="form" (keyup.enter)="register()">
        <mat-form-field appearance="outline">
          <!-- <mat-label>Email</mat-label> -->
          <input
            matInput
            placeholder="Email"
            type="email"
            name="email"
            formControlName="emailControl"
          />
          <mat-error
            for="register-email"
            class="form-error"
            *ngIf="
              (!registerForm.controls['emailControl'].pristine ||
                registerForm.controls['emailControl'].touched) &&
              registerForm.controls['emailControl'].invalid
            "
          >
            {{ utils.getErrorMessage(registerForm.controls['emailControl'].errors) }}
          </mat-error>
        </mat-form-field>
        <!-- <span>Contraseña</span> -->
        <mat-form-field appearance="outline">
          <!-- <mat-label>Contraseña</mat-label> -->
          <input
            matInput
            [type]="seePassword ? 'text' : 'password'"
            placeholder="Contraseña"
            name="password"
            formControlName="passwordControl"
          />
          <img
            class="eye-icon"
            src="assets/icons/eye.svg"
            *ngIf="!seePassword"
            (click)="seePassword = true"
            alt=""
          />
          <img
            class="eye-off-icon"
            src="assets/icons/eye-off.svg"
            *ngIf="seePassword"
            (click)="seePassword = false"
            alt=""
          />
          <mat-error
            for="register-password"
            class="form-error"
            *ngIf="
              (!registerForm.controls['passwordControl'].pristine ||
                registerForm.controls['passwordControl'].touched) &&
              registerForm.controls['passwordControl'].invalid
            "
          >
            {{ utils.getErrorMessage(registerForm.controls['passwordControl'].errors) }}
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline">
          <!-- <mat-label>Repetir Contraseña</mat-label> -->
          <input
            matInput
            [type]="seeRepPassword ? 'text' : 'password'"
            placeholder="Repetir contraseña"
            name="password"
            formControlName="passRepControl"
          />
          <img
            class="eye-icon"
            src="assets/icons/eye.svg"
            *ngIf="!seeRepPassword"
            (click)="seeRepPassword = true"
            alt=""
          />
          <img
            class="eye-off-icon"
            src="assets/icons/eye-off.svg"
            *ngIf="seeRepPassword"
            (click)="seeRepPassword = false"
            alt=""
          />
          <mat-error
            for="register-password"
            class="form-error"
            *ngIf="
              (!registerForm.controls['passRepControl'].pristine ||
                registerForm.controls['passRepControl'].touched) &&
              registerForm.controls['passRepControl'].invalid
            "
          >
            {{ utils.getErrorMessage(registerForm.controls['passRepControl'].errors) }}
          </mat-error>
        </mat-form-field>
        <button class="td-btn primary" (click)="register()">Registrarme</button>
      </div>
    </div>

    <div class="options">
      <div class="option">
        <p class="text" *ngIf="!loading" (click)="router.navigate(['auth', 'login'])">
          ¿Ya tenés cuenta? Iniciá sesión
        </p>
      </div>
    </div>

    <div class="footer">
      <p class="text" (click)="utils.openTyc()">Términos y Condiciones</p>
      <p class="text">© TiendaCrypto {{ utils.actualYear }}</p>
    </div>
  </div>
</div>
